import { metrics } from '@seek/metrics-js';

let timeToInteractiveRun = false;

export const timeToInteractive = () => {
  if (
    !timeToInteractiveRun &&
    window.performance &&
    typeof window.performance.now === 'function'
  ) {
    metrics.timing('time-to-interative', window.performance.now());
    timeToInteractiveRun = true;
  }
};
